module.exports = __webpack_public_path__ + "static/img/logo.0a3e1f6e.png";